import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const previewContainerStyle = css`
  background-color: ${theme.colors.neutral5};
  flex: 1;
`;

export const formsExperienceViewContainerStyle = css`
  height: 100%;
  padding-top: ${theme.spacing(2)};

  > div {
    height: 100%;
  }
`;
